import {React} from 'components';

export default (props) => <input type='hidden' {...props}/>;
